import React from 'react'
import './EmotionDisplay.css'

const EmotionDisplay = ({ emotion, isActive }) => {
  const getEmotionIcon = (emotionName) => {
    const icons = {
      happy: '😊',
      sad: '😢',
      angry: '😠',
      surprised: '😲',
      disgusted: '🤢',
      fearful: '😨',
      neutral: '😐'
    }
    return icons[emotionName] || '🤔'
  }

  const getEmotionColor = (emotionName) => {
    const colors = {
      happy: '#00ff88',
      sad: '#4a9eff',
      angry: '#ff4444',
      surprised: '#ffaa00',
      disgusted: '#8b5cf6',
      fearful: '#ff6b6b',
      neutral: '#cccccc'
    }
    return colors[emotionName] || '#cccccc'
  }

  const getEmotionDescription = (emotionName) => {
    const descriptions = {
      happy: 'Joy and contentment detected',
      sad: 'Sadness and melancholy detected',
      angry: 'Anger and frustration detected',
      surprised: 'Surprise and astonishment detected',
      disgusted: 'Disgust and aversion detected',
      fearful: 'Fear and anxiety detected',
      neutral: 'Neutral expression detected'
    }
    return descriptions[emotionName] || 'Emotion analysis in progress'
  }

  if (!isActive) {
    return (
      <div className="emotion-display">
        <div className="emotion-header">
          <h3 className="emotion-title">Emotion Analysis</h3>
          <span className="emotion-status inactive">Inactive</span>
        </div>
        
        <div className="emotion-placeholder">
          <div className="placeholder-icon">🎭</div>
          <h4>No Active Detection</h4>
          <p>Start the camera to begin emotion analysis</p>
        </div>
      </div>
    )
  }

  if (!emotion) {
    return (
      <div className="emotion-display">
        <div className="emotion-header">
          <h3 className="emotion-title">Emotion Analysis</h3>
          <span className="emotion-status searching">Searching...</span>
        </div>
        
        <div className="emotion-placeholder">
          <div className="placeholder-icon pulse">👁️</div>
          <h4>Looking for Faces</h4>
          <p>Position your face in the camera view</p>
        </div>
      </div>
    )
  }

  const emotionColor = getEmotionColor(emotion.emotion)
  const emotionIcon = getEmotionIcon(emotion.emotion)
  const emotionDescription = getEmotionDescription(emotion.emotion)

  return (
    <div className="emotion-display">
      <div className="emotion-header">
        <h3 className="emotion-title">Emotion Analysis</h3>
        <span className="emotion-status active">Active</span>
      </div>

      <div className="current-emotion">
        <div 
          className="emotion-icon"
          style={{ color: emotionColor }}
        >
          {emotionIcon}
        </div>
        
        <div className="emotion-details">
          <h4 className="emotion-name" style={{ color: emotionColor }}>
            {emotion.emotion.charAt(0).toUpperCase() + emotion.emotion.slice(1)}
          </h4>
          <p className="emotion-description">{emotionDescription}</p>
        </div>
      </div>

      <div className="confidence-section">
        <h5 className="confidence-title">Confidence Score</h5>
        <div className="confidence-bar">
          <div 
            className="confidence-fill"
            style={{ 
              width: `${emotion.confidence}%`,
              backgroundColor: emotionColor
            }}
          ></div>
        </div>
        <span className="confidence-text">{emotion.confidence}%</span>
      </div>

      <div className="all-emotions">
        <h5 className="all-emotions-title">All Emotions</h5>
        <div className="emotion-list">
          {Object.entries(emotion.allEmotions)
            .sort(([,a], [,b]) => b - a)
            .map(([emotionName, confidence]) => (
              <div key={emotionName} className="emotion-item">
                <div className="emotion-item-header">
                  <span className="emotion-item-icon">
                    {getEmotionIcon(emotionName)}
                  </span>
                  <span className="emotion-item-name">
                    {emotionName.charAt(0).toUpperCase() + emotionName.slice(1)}
                  </span>
                  <span className="emotion-item-confidence">
                    {Math.round(confidence * 100)}%
                  </span>
                </div>
                <div className="emotion-item-bar">
                  <div 
                    className="emotion-item-fill"
                    style={{ 
                      width: `${confidence * 100}%`,
                      backgroundColor: getEmotionColor(emotionName)
                    }}
                  ></div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <div className="emotion-info">
        <div className="info-item">
          <span className="info-icon">🎯</span>
          <span className="info-text">Real-time analysis using AI</span>
        </div>
        <div className="info-item">
          <span className="info-icon">📊</span>
          <span className="info-text">7 emotion categories detected</span>
        </div>
      </div>
    </div>
  )
}

export default EmotionDisplay 